export const blacklist = [
  'script',
];
